import { createContext } from 'react'

/**
 * Context containing the current session's authenticated user.
 */
export const UserContext = createContext()

export default UserContext
